<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Headers from "./table_headers";
import HeadersLOP from "./table_headers_lop";
import LeaseService from "./leaseService";
import axios from "@/axios";
import ExportButton from "@/components/export-button";
import WebPayModal from "@/components/web-pay-modal/web-pay-modal";
import ReferenceModal from "./modal/ReferenceModal";
import i18n from "@/i18n";
import { b64toBlob } from "@/utils";
import DPConfig from "../../../components/dataPickerConf";
import Filter from "@/components/filters/Filter";
import { getDateWithFormat, formatCurrency, thousandSeparator } from "@/utils";

export default {
  page: {
    title: i18n.t("lease.title"),
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    "export-button": ExportButton,
    "web-pay-modal": WebPayModal,
    "reference-modal": ReferenceModal,
    filters: Filter,
  },
  props: {
    query: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      lang: {
        formatLocale: DPConfig.formatLocale,
      },
      filtersValue: {
        rutEmpresa: 0,
        leaseType: "reserva",
        inputNumber: "",
        period: [new Date("2000-01-01"), new Date()],
      },
      labelNumber: undefined,
      tableData: [],
      valuePagination: {
        default: 1,
      },
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      totRegistros: 1,
      filter: null,
      filterOn: [],
      sortBy: "Nro. Documento",
      sortDesc: true,
      fields:
        this.$route.name === "arriendosLop"
          ? HeadersLOP.contrato
          : Headers.reservation,
      period: [new Date("2000-01-01"), new Date()],
      isBusy: false,
      isBusy2: false,
      buttonClicked: undefined,
      files: null,
      dataExport: []
    };
  },
  beforeMount() {
    if (this.$route.name === "arriendosLop") {
      this.filtersValue.leaseType = "contratoLop";
    }
  },
  methods: {
    getDate(date) {
      return getDateWithFormat(date);
    },
    getCurrency(inport) {
      return formatCurrency(inport);
    },
    getNumberWithSeparators(number) {
      return thousandSeparator(number);
    },
    chooseTable() {
      this.filtersValue["period"] = null
      if (this.filtersValue.leaseType === "reserva") {
        this.filtersValue["inputNumber"] = "";
        this.filtersValue["period"] = [new Date("2000-01-01"), new Date()];
        this.labelNumber = "Número"
        this.fields = Headers.reservation;
      } else if (
        this.filtersValue.leaseType === "contrato" ||
        this.filtersValue.leaseType === "contratoLop"
      ) {
        if (this.$route.name === "arriendosLop") {
          this.filtersValue["inputNumber"] = undefined;
          this.filtersValue["period"] = undefined;
          this.fields = HeadersLOP.contrato;
          this.labelNumber = "Número"
        } else {
          this.filtersValue["inputNumber"] = "";
          this.filtersValue["period"] = [new Date("2000-01-01"), new Date()];
          this.fields = Headers.contract;
          this.labelNumber = "Número"
        }
      } else if (
        this.filtersValue.leaseType === "boleta" ||
        this.filtersValue.leaseType === "boletaLop"
      ) {
        this.filtersValue["inputNumber"] = "";
        if (this.$route.name === "arriendosLop") {
          this.filtersValue["period"] = [new Date("2000-01-01"), new Date()];
        } else {
          this.filtersValue["period"] = [new Date("2000-01-01"), new Date()];
        }
        this.fields =
          this.$route.name === "arriendosLop"
            ? HeadersLOP.boleta_factura
            : Headers.boleta_factura;
        this.labelNumber = "Número Contrato"
      } else if (
        this.filtersValue.leaseType === this.$t("lease.quotation.id") ||
        this.filtersValue.leaseType === "cotizacionLop"
      ) {
        if (this.$route.name === "arriendosLop") {
          this.filtersValue["inputNumber"] = undefined;
          this.filtersValue["period"] = [new Date("2000-01-01"), new Date()];
          this.fields = HeadersLOP.cotizacion;
          this.labelNumber = "Número"
        } else {
          this.filtersValue["inputNumber"] = "";
          this.filtersValue["period"] = [new Date("2000-01-01"), new Date()];
          this.fields = Headers.quotation;
          this.labelNumber = "Número"
        }
      } else if (
        this.filtersValue.leaseType === this.$t("lease.reference.id")
      ) {
        this.filtersValue["inputNumber"] = "";
        this.filtersValue["period"] = [new Date("2000-01-01"), new Date()];
        this.fields = Headers.reference;
        this.labelNumber = "Número Contrato"
      }
      this.getData();
    },
    getData() {
      if (this.filtersValue.rutEmpresa) {
        if (this.filtersValue.leaseType === "reserva") {
          this.abstractMeodToGet("getReservations");
        } else if (
          this.filtersValue.leaseType === "contrato" ||
          this.filtersValue.leaseType === "contratoLop"
        ) {
          this.getContratos();
        } else if (
          this.filtersValue.leaseType === "boleta" ||
          this.filtersValue.leaseType === "boletaLop"
        ) {
          this.getFacturas();
        } else if (
          this.filtersValue.leaseType === this.$t("lease.quotation.id") ||
          this.filtersValue.leaseType === "cotizacionLop"
        ) {
          this.getCotizacion();
        } else if (
          this.filtersValue.leaseType === this.$t("lease.reference.id")
        ) {
          this.abstractMeodToGet("getReferences");
        }
      }
    },
    getContratos() {
      if (this.$route.name === "arriendosLop") {
        this.abstractMeodToGet("getContratosLop");
      } else {
        this.abstractMeodToGet("getContratosRac");
      }
    },
    getCotizacion() {
      if (this.$route.name === "arriendosLop") {
        this.abstractMeodToGet("getCotizaciones");
      } else {
        this.abstractMeodToGet("getQuotesRac");
      }
    },
    getFacturas() {
      if (this.$route.name === "arriendosLop") {
        this.$store.dispatch("hideValue/updateFilter", this.filtersValue);
        this.abstractMeodToGet("getDocumentos");
      } else {
        this.abstractMeodToGet("getDocumentsRac");
      }
    },
    abstractMeodToGet(methodName) {
      this.isBusy = true;
      LeaseService[methodName]({ ...this.getParams() })
        .then((reservas) => {
          this.tableData = reservas.data.datos;
          this.totRegistros = reservas.data.totalRegistros;
          this.abstractGetToExport(methodName)
          this.isBusy = false;
        })
        .catch((error) => {
          if (error.response) {
            this.$bvToast.toast(
              this.$t("lease.request.error.message").toString(),
              {
                title: this.$t("lease.request.error.nonFound").toString(),
                variant: "danger",
                solid: true,
              }
            );
          }
          this.isBusy = false;
        });
    },
    abstractGetToExport(methodName) {
      this.isBusy2 = true
      LeaseService[methodName]({ ...this.getParamsToExport() })
          .then((reservas) => {
            this.dataExport = reservas.data.datos;
            this.isBusy2 = false
          })
    },
    isButtonDisabled(row) {
      if (this.filtersValue.leaseType === "reserva") {
        return !row.item.numero
      } else if (
        this.filtersValue.leaseType === "contrato" ||
        this.filtersValue.leaseType === "contratoLop"
      ) {
        if (this.$route.name === "arriendosLop") {
          return !row.item.numero
        } else {
          return !row.item.liquidacion || !row.item.numero
        }
      } else if (this.filtersValue.leaseType === "boleta") {
        return !row.item.ctaCteNroDocto
      } else if (this.filtersValue.leaseType === "boletaLop") {
        return !row.item.numeroDocumento
      } else if (
        this.filtersValue.leaseType === this.$t("lease.quotation.id") ||
        this.filtersValue.leaseType === "cotizacionLop"
      ) {
        return !row.item.numero
      }
    },
    download(row) {
      let fileName;
      let fileType = "application/pdf";
      let downloadRequest;
      if (this.filtersValue.leaseType === "reserva") {
        downloadRequest = axios.get(`/PdfReserva/${row.item.numero}`);
        fileName = `reserva_${row.item.numero}.pdf`;
      } else if (
        this.filtersValue.leaseType === "contrato" ||
        this.filtersValue.leaseType === "contratoLop"
      ) {
        if (this.$route.name === "arriendosLop") {
          downloadRequest = axios.get(`/PdfReserva/${row.item.numero}`);
          fileName = `reserva_${row.item.numero}.pdf`;
        } else {
          downloadRequest = axios.get(
            `/GetLiquidacionByNumero/${row.item.liquidacion}/${row.item.numero}`
          );
          fileName = `liquidacion_${row.item.liquidacion}.pdf`;
        }
      } else if (this.filtersValue.leaseType === "boleta") {
        let requestBody = {
          fElecParEmpCod: row.item.empCod,
          fElecDocTipo: row.item.evenTipoDoc,
          fElecDocNro: row.item.ctaCteNroDocto,
        };
        downloadRequest = axios.post("/ObtenerDocumento", requestBody);
        let name = row.item.evenTipoDesc ? row.item.evenTipoDesc : 'BOLETA';
        name = name.replace(/\s+/g,'_'); // reemplaza espacios en blanco
        fileName = `${name}_${row.item.ctaCteNroDocto}.pdf`;
      } else if (this.filtersValue.leaseType === "boletaLop") {
        let requestBody = {
          FElecParEmpCod: "1",
          FElecDocTipo: row.item.tipoDocumento,
          FElecDocNro: `${row.item.numeroDocumento}`,
        };
        downloadRequest = axios.post("/ObtenerDocumento", requestBody);
        let name = row.item.evenTipoDesc ? row.item.evenTipoDesc : 'BOLETA';
        name = name.replace(/\s+/g,'_'); // reemplaza espacios en blanco
        fileName = `${name}_${row.item.numeroDocumento}.pdf`;
      } else if (
        this.filtersValue.leaseType === this.$t("lease.quotation.id") ||
        this.filtersValue.leaseType === "cotizacionLop"
      ) {
        fileName = `cotizacion_${row.item.numero}.pdf`;
        downloadRequest = LeaseService.downloadCotizacion(row.item.numero);
      }
      this.buttonClicked = row.index;
      downloadRequest
        .then((documento) => {
          if (documento.data.pdf || documento.data.bDatos) {
            const pdf = documento.data.pdf
              ? documento.data.pdf
              : documento.data.bDatos;
            const blob = b64toBlob(pdf, fileType);
            let fileURL = window.URL.createObjectURL(blob);
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
            this.buttonClicked = undefined;
          } else {
            this.$bvToast.toast(
              this.$t("lease.pdf.error.nonFound").toString(),
              {
                title: this.$t("lease.pdf.error.download").toString(),
                variant: "danger",
                solid: true,
              }
            );
            this.buttonClicked = undefined;
          }
        })
        .catch(() => {
          this.$bvToast.toast(this.$t("lease.pdf.error.nonFound").toString(), {
            title: this.$t("lease.pdf.error.download").toString(),
            variant: "danger",
            solid: true,
          });
          this.buttonClicked = undefined;
        });
    },
    nuevaReserva() {
      window.open("https://mitta.cl/datos-de-reserva/", "_blank");
    },
    toWhere() {
      if (this.filtersValue.leaseType === "reserva") {
        return "detalleReserva";
      } else if (this.filtersValue.leaseType === "contrato") {
        return "detalleContrato";
      } else if (this.filtersValue.leaseType === "cotizacionLop") {
        return "detalleCotizacionLOP";
      } else if (this.filtersValue.leaseType === "cotizacion") {
        return "detalleCotizacion";
      }
    },
    getParams() {
      return {
        currentPage: this.currentPage,
        perPage: this.perPage,
        rutEmpresa: this.filtersValue.rutEmpresa,
        inputNumero: this.filtersValue.inputNumber,
        daterange: [this.filtersValue.period[0], this.filtersValue.period[1]],
        RutContacto: this.$store.getters["auth/contacto"].identificador,
      };
    },
    getParamsToExport() {
      return {
        currentPage: 1,
        perPage: this.totRegistros,
        rutEmpresa: this.filtersValue.rutEmpresa,
        inputNumero: this.filtersValue.inputNumber,
        daterange: [this.filtersValue.period[0], this.filtersValue.period[1]],
        RutContacto: this.$store.getters["auth/contacto"].identificador,
      };
    },
    goDetalleBoleta(boletaFactura) {
      this.$store.dispatch("docs/addBoleta", boletaFactura);
      this.$router.push({
        name: "detalleFacturaLOP"
      });
    },
    onFileSelected(event) {
      this.files = event.target.files;
    },
    detailView(id, confRoute) {
      if (confRoute === "documentos") {
        this.$store.dispatch("hideValue/updatePatente", id);
      } else {
        this.$store.dispatch("hideValue/updateId", id);
        this.$store.dispatch("hideValue/updateFilter", this.filtersValue);
      }
      this.$router.push(confRoute);
    },
    getLabelNumero() {
      if (
        this.filtersValue.type === "boleta" ||
        this.filtersValue.type === "boletaLop"
      ) {
        return "Número de factura/boleta";
      } else if (
        this.filtersValue.type === "referencias" ||
        this.filtersValue.type === "contratoLop"
      ) {
        return "Número de contrato";
      } else if (
        this.filtersValue.type === "cotizacion" ||
        this.filtersValue.type === "cotizacionLop"
      ) {
        return "Número de cotización";
      }
      return "Número de " + this.filtersValue.type;
    },
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
};
</script>
<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">Mis Arriendos</h4>
              <export-button
                v-if="!isBusy2"
                :data="dataExport"
                :fileName="filtersValue.leaseType"
              />
              <b-spinner v-else small class="align-middle"></b-spinner>
            </b-row>
            <filters
              v-model="filtersValue"
              @change="getData"
              @chooseTable="chooseTable"
              :labelNumber="labelNumber"
            />
            <b-row>
              <b-col sm="12" md="6" lg="3">
                <b-button
                  v-if="filtersValue.leaseType === 'reserva'"
                  variant="danger"
                  block
                  @click="nuevaReserva()"
                  class="mb-3"
                  >Realizar una reserva
                </b-button>
              </b-col>
            </b-row>
            <!-- Inicio Tabla -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :busy="isBusy"
                show-empty
              >
                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <p class="pBusy">TIP: Seleccione un <span>Período</span> para acotar la búsqueda</p>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->
                <template>
                  <h5 style="text-align: center">
                  {{ $t("request.table.empty") }} 
                  </h5>
                </template> 
                
                <!-- Rows compartidos -->
                <template #cell(fechaDesde)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(fechaHasta)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(numero)="row">
                  <a
                    v-if="
                      filtersValue.leaseType !== 'cotizacionLop' ||
                      (filtersValue.leaseType === 'cotizacionLop' &&
                        row.item['comprado'])
                    "
                    @click="
                      detailView(row.value, {
                        name: toWhere(),
                      })
                    "
                    class="links"
                  >
                    {{ row.value }}
                  </a>

                  <p v-else>{{ row.value }}</p>
                </template>
                <template #cell(factura_Boleta)="row">
                  <a
                    @click="
                      detailView(row.value, {
                        name: 'detalleFactura',
                        query: { T: row.item.documentoTipo },
                      })
                    "
                    class="links"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <!-- Rows de Reserva -->
                <template #cell(patente)="row">
                  <a v-if="row.value"
                    class="links"
                    @click="detailView(row.item.patente.trim(), 'documentos')"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(contrato)="row">
                  <a
                    v-if="$route.name !== 'arriendosLop'"
                    @click="detailView(row.value, { name: 'detalleContrato' })"
                    class="links"
                  >
                    {{ row.value }}
                  </a>
                  <a
                    v-else
                    @click="
                      detailView(row.value, {
                        name: 'documentacionContrato',
                      })
                    "
                    class="links"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(cantidaVehciulos)="row">
                  <router-link :to="{ name: 'detalle-flota' }">
                    {{ getNumberWithSeparators(row.value) }}
                  </router-link>
                </template>

                <!-- Rows de Contrato -->
                <template #cell(fechaInicio)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(fechaTermino)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(numeroReserva)="row">
                  <a
                    @click="
                      detailView(row.value, {
                        name: 'detalleReserva',
                      })
                    "
                    class="links"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(reserva)="row">
                  <a
                    @click="
                      detailView(row.value, {
                        name: 'detalleReserva',
                      })
                    "
                    class="links"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(liquidacion)="row">
                  <!-- Special case check the extraparam in the logic of filter component -->
                  <a
                    @click="
                      detailView(row.value, {
                        name: 'detalleLiquidacion',
                        params: { contrato: row.item.numero }
                      })
                    "
                    class="links"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template>
                <!-- <template #cell(loadReference)=""> -->
                  <span class="hidden-file">
                    <input
                      type="file"
                      ref="fileInput"
                      @change="onFileSelected($event)"
                      accept=".pdf,.jpg,.jpeg,.png"
                    />
                  </span>
                  <div class="text-center">
                    <b-button variant="danger" @click="$refs.fileInput.click()">
                      <i class="bx bx-upload font-size-16 align-middle" />
                    </b-button>
                  </div>
                </template>
                <template #cell(sendReference)="row">
                  <div class="text-center">
                    <reference-modal
                      :index="row.index"
                      :reference="row.item"
                      :files="files"
                    />
                  </div>
                </template>
                
                <!-- Rows de Boleta/Factura -->
                <template #cell(descarga)="row">
                  <div class="text-center" :id="`download-arriendos-${row.item.numero || row.item.ctaCteNroDocto}`">
                    <b-button variant="danger" @click="download(row)" :disabled="isButtonDisabled(row)">
                      <i
                        v-if="buttonClicked !== row.index"
                        class="bx bx-download font-size-16 align-middle"
                      />
                      <b-spinner v-else small class="align-middle"></b-spinner>
                      <b-tooltip :target="`download-arriendos-${row.item.numero || row.item.ctaCteNroDocto}`" 
                        triggers="hover" placement="rigth" v-if="isButtonDisabled(row)">
                        No existen documentos disponibles
                      </b-tooltip>
                    </b-button>
                  </div>
                </template>
                <template #cell(pagar)="row">
                  <web-pay-modal :index="row.index" :document="row.item" v-if="row.item.estado !== 'Anulado'" />
                </template>
                <template #cell(contratO_IdContrato)="row">
                  <a
                    @click="detailView(row.value, { name: 'detalleContrato' })"
                    class="links"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(contratO_IdReserva)="row">
                  <a
                    @click="detailView(row.value, { name: 'detalleReserva' })"
                    class="links"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(ctaCteNroDocto)="row">
                  <a
                    @click="
                      detailView(row.value, {
                        name: 'detalleFactura',
                        query: { T: row.item.evenTipoDoc },
                      })
                    "
                    class="links"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(numeroDocumento)="row">
                  <a class="pointer links" @click="goDetalleBoleta(row.item)">
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(ctaCteFecEmision)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(ctaCteTotal)="row">
                  {{ "$" + getCurrency(row.value) }}
                </template>
                <template #cell(ctaCteSaldo)="row">
                  {{ "$" + getCurrency(row.value) }}
                </template>
                <template #cell(fechaEmision)="row">
                  {{ getDate(row.value) }}
                </template>
                <template #cell(totalDocumento)="row">
                  {{ "$" + getCurrency(row.value) }}
                </template>
                <template #cell(saldoDocumento)="row">
                  {{ "$" + getCurrency(row.value) }}
                </template>
              </b-table>
            </div>
            
            <!-- Fin Tabla -->
            <!-- Inicio Paginación -->
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination
                                    @page-click="changePage"-->
                  <b-pagination
                    class="portal"
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totRegistros"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss">
a,
.pointer {
  cursor: pointer;
}

.hidden-file {
  display: none;
}

.pBusy {
  margin-top: .5rem; 
  color: #000; 
  font-weight: 500;
  font-style: italic;
}

.pBusy > span {
  font-weight: 600;
  font-style: normal;
}
</style>
